import ConsultaBase from "../shared/ConsultaBase";
import { fullServiceCoolingV3ConsultaConfig } from "../config/fullServiceCoolingV3Consulta";

const CFSCV3 = () => {
  return <ConsultaBase config={fullServiceCoolingV3ConsultaConfig} />;
};

export default CFSCV3;